import { SDK } from "../sdk"

const client = new SDK(
    {
        url: process.env.API_URL,
        storage: typeof window !== "undefined" ? window.localStorage : undefined,
        storageKey: process.env.STORAGE_KEY,
        crossDomain: process.env.COOKIE_DOMAIN,
        uid: process.env.API_UID,
        password: process.env.API_PASSWORD,
        serverSideCookies: process.env.NO_SERVER_SIDE_COOKIES !== "true",
    },
)

// for dev purpose make client a global variable
if (process.env.NODE_ENV === "development" && typeof window !== "undefined") {
    window.client = client
}

export default client
